'use client';
import React from 'react';

interface BrandSunIconSelectorProps {
	type: 'sunshine' | 'moonlight' | 'sunset';
}


const BrandSunMotif: React.FC<BrandSunIconSelectorProps> = ({ type = 'sunshine' }) => {
	let iconSrc: string;

	if (type === 'sunshine') {
		iconSrc = '/Sun-Motif-Sunshine.svg';
	} else if (type === 'moonlight') {
		iconSrc = '/Sun-Motif-Moonlight.svg';
	} else {
		iconSrc = '/Sun-Motif-Sunset.svg';
	}

	return <img src={iconSrc} alt="Brand Sun Motif"  className='w-[36px] lg:w-[40px] aspect-square'/>;
};

export default BrandSunMotif;
